/* Add an `is-compact` class to the sticky header group when the page is
   scrolled past a small threshold. CSS handles the visual compaction. */
(function () {
  if (window.__headerCompactInit) return;
  window.__headerCompactInit = true;

  const THRESHOLD = 40;
  let target = null;

  function findTarget() {
    // Header section wrapper, excluding the announcement bar section.
    return Array.from(document.querySelectorAll('.shopify-section[id*="__header"]'))
      .find((el) => !/announcement/i.test(el.id)) || null;
  }

  function tick() {
    if (!target) target = findTarget();
    if (!target) return;

    // Mobile (<990px) uses the always-on compact bar defined in the header
    // section CSS; the scroll-driven compaction is desktop-only. Clear the
    // classes on mobile (e.g. after resizing down from desktop) so the two
    // layouts never fight.
    if (window.innerWidth < 990) {
      if (target.classList.contains('is-compact')) {
        target.classList.remove('is-compact');
        document.body.classList.remove('header-is-compact');
        const headerEl = target.querySelector('.header-wrapper, .header') || target;
        document.documentElement.style.setProperty('--header-height', headerEl.offsetHeight + 'px');
      }
      return;
    }

    const y = window.scrollY || window.pageYOffset || 0;
    const should = y > THRESHOLD;
    if (target.classList.contains('is-compact') === should) return;

    // Capture the header's height before the layout change so we can
    // scroll-correct the visual jump caused by the height delta.
    const headerEl = target.querySelector('.header-wrapper, .header') || target;
    const beforeH = target.getBoundingClientRect().height;

    target.classList.toggle('is-compact', should);
    document.body.classList.toggle('header-is-compact', should);

    // After the layout settles, measure the new height and compensate.
    const afterH = target.getBoundingClientRect().height;
    const delta = beforeH - afterH;
    if (delta !== 0) {
      // Scroll by the same delta so visible content doesn't jump.
      window.scrollBy({ top: delta, left: 0, behavior: 'instant' });
    }
    document.documentElement.style.setProperty(
      '--header-height',
      headerEl.offsetHeight + 'px'
    );
  }

  window.addEventListener('scroll', tick, { passive: true });
  window.addEventListener('resize', tick, { passive: true });
  document.addEventListener('DOMContentLoaded', tick);
  document.addEventListener('shopify:section:load', () => {
    target = null;
    tick();
  });
  tick();
})();
